import { trpc } from "@/lib/trpc";
import { useEffect, useState } from "react";

function formatUptime(seconds: number): string {
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  
  if (days > 0) {
    return `${days}d ${hours}h`;
  }
  if (hours > 0) {
    return `${hours}h`;
  }
  const minutes = Math.floor(seconds / 60);
  return `${minutes}m`;
}

function formatTimeSince(date: Date | null): string {
  if (!date) return "N/A";
  
  const now = new Date();
  const diffMs = now.getTime() - new Date(date).getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  
  if (diffSeconds < 60) return `${diffSeconds}s`;
  if (diffSeconds < 3600) return `${Math.floor(diffSeconds / 60)}m`;
  if (diffSeconds < 86400) return `${Math.floor(diffSeconds / 3600)}h`;
  return `${Math.floor(diffSeconds / 86400)}d`;
}

export function SystemStatusHeader() {
  const { data, refetch } = trpc.systemStatus.status.useQuery(undefined, {
    refetchInterval: 30000, // Atualiza a cada 30s
  });

  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!data) return null;

  const statusItems = [
    {
      label: "Servidor",
      value: formatUptime(data.serverUptime),
      status: "ok" as const,
    },
    {
      label: "Aplicação",
      value: formatUptime(data.appUptime),
      status: "ok" as const,
    },
    {
      label: "MySQL",
      value: data.mysqlStatus,
      status: data.mysqlStatus === "OK" ? ("ok" as const) : ("error" as const),
    },
    {
      label: "Última",
      value: formatTimeSince(data.lastMovementTime),
      status: "ok" as const,
    },
  ];

  return (
    <div className="bg-zinc-900 border-b border-zinc-800 px-4 py-2">
      <div className="container mx-auto flex items-center justify-end gap-4 text-xs">
        <div className="flex items-center gap-6">
          {statusItems.map((item, idx) => (
            <div key={idx} className="flex items-center gap-2">
              <span
                className={`inline-block w-2 h-2 rounded-full ${
                  item.status === "ok" ? "bg-green-500" : "bg-red-500"
                }`}
              />
              <span className="text-zinc-400">{item.label}:</span>
              <span className="text-zinc-200 font-medium">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
